export default __webpack_public_path__ + "media/Number10.f0b7f228be684d6abd6b7d5dca5881d1.mp4";